export default {"src":"https://static.eleduck.com/_next/static/media/medal-1.7346b229.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};